import PaperLayout from "./PaperLayout";
export * from "./PaperLayout";
export default PaperLayout;
